import React from 'react';
import { useBrandIdentity } from '../utils/brandIdentity';

// Brand-first plans (Partner): the company's name leads these titles, e.g. "Vector Overview".
const BRANDED_TITLES = new Set(['Overview', 'Portfolio Simulator', 'Risk Tools', 'Blowout Risk', '% Rule Risk', 'Hedging Risk', 'Trade Watcher']);

/** Shared workspace page title — gradient h1 rendered above each main page's
 *  body so the sidebar destination is always reflected on screen.
 *  Optional `description` renders as a small line under the title, fitting into
 *  the existing heading gap (no extra vertical space).
 *  Optional `badge` renders inline after the title text (e.g. a Beta chip). */
function PageHeading({ title: rawTitle, description, badge = null, className = '' }) {
  const identity = useBrandIdentity();
  if (!rawTitle) return null;
  const title = identity.plan === 'partner' && typeof rawTitle === 'string' && BRANDED_TITLES.has(rawTitle) ? `${identity.appName} ${rawTitle}` : rawTitle;
  if (description) {
    return (
      <div className={`app-page-heading-block ${className}`.trim()}>
        <h1 className="app-page-heading app-page-heading--with-desc">{title}{badge}</h1>
        <p className="app-page-heading-desc">{description}</p>
      </div>
    );
  }
  return (
    <h1 className={`app-page-heading ${className}`.trim()}>{title}{badge}</h1>
  );
}

export default PageHeading;
